import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HonestQuestion } from './components/HonestQuestion';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludesSection } from './components/IncludesSection';
import { BeforeAfter } from './components/BeforeAfter';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { ClosingSection } from './components/ClosingSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MobileStickyButton } from './components/MobileStickyButton';
export function App() {
  useEffect(() => {
    // Preconnect to CDN for faster image loading (150ms LCP saving)
    const cdnPreconnect = document.createElement('link');
    cdnPreconnect.rel = 'preconnect';
    cdnPreconnect.href = 'https://cdn.magicpatterns.com';
    document.head.appendChild(cdnPreconnect);
    // Preload Google Fonts non-blocking
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap';
    fontLink.media = 'print';
    fontLink.onload = () => {
      fontLink.media = 'all';
    };
    document.head.appendChild(fontLink);
    // Meta Pixel - load immediately for accurate tracking
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '947072064512852');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(pixelScript);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=947072064512852&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(cdnPreconnect);
      document.head.removeChild(fontLink);
      document.head.removeChild(pixelScript);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-gray-100 font-sans selection:bg-yellow-300 selection:text-gray-900" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HonestQuestion data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <IncludesSection data-id="element-7" />
        <BeforeAfter data-id="element-8" />
        <TomosSection data-id="element-9" />
        <BonusSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <FAQSection data-id="element-14" />
        <ClosingSection data-id="element-15" />
      </main>
      <SocialProofPopup data-id="element-16" />
      <MobileStickyButton data-id="element-17" />
    </div>;
}